export const MultiselectDT = {
	multiselect: {
		css: ({ dt }) => `
          .p-multiselect--wrapper-label {
              .p-multiselect-label {
                  white-space: break-spaces;
                  display: flex;
                  flex-wrap: wrap;
              }
          }
          .p-multiselect-label {
              flex-wrap: wrap;
          }
          .p-multiselect--full-width {
              width: 100%;
          }
        `,
	},
};
